import {useCallback} from 'react';
import {useMobileNavigationContext} from "../context/mobile-navigation-context.jsx";

export const useCheckItemActive = () => {
    const {activeIds} = useMobileNavigationContext();
    return useCallback(
        (item) => {
            return !!item &&  activeIds.includes(item.id) && !item.overviewItem
        },
        [activeIds],
    );
};
